import React, { useState, useEffect, useRef } from "react";

import BcSepIcon from "../../asset/images/about/breadcrumb-separator.svg";

import HeroBgImg from "../../asset/images/products/3-phase/hero-bg.webp";
import SlideImg1 from "../../asset/images/products/3-phase/slide-1.webp";
import SlideImg2 from "../../asset/images/products/3-phase/slide-2.webp";
import SlideImg3 from "../../asset/images/products/3-phase/slide-3.webp";
import SlideImg4 from "../../asset/images/products/3-phase/slide-4.webp";
import SpecImg   from "../../asset/images/products/3-phase/spec-image.webp";
import FeaturesTabIcon from "../../asset/images/products/1-phase/features-icon.svg";
import SpecTabIcon     from "../../asset/images/products/1-phase/spec-icon.svg";
import DownloadTabIcon from "../../asset/images/products/1-phase/download-icon.svg";
import PdfSvgIcon      from "../../asset/images/products/1-phase/pdf-icon.svg";


const SLIDES = [SlideImg1, SlideImg2, SlideImg3, SlideImg4];
const AUTOPLAY_SPEED = 4500; // ms — change this to control speed

const SALIENT_FEATURES = [
  "Versatile T/R set construction:",
  "Hermetically Sealed type with Corrugated fin;",
  "Conventional with Conservator tank, with & without Breather;",
  "Conventional Sealed type &",
  "Nitrogen-filled tank with radiator",
  "HV transformer, Current-limiting reactor, Rectifier & HF choke are all integrated within the TR tank for ease of maintenance & repairs.",
  "Conforms to IP-65 as per IEC PUB 947-1",
  "HF choke provides excellent surge-protection of rectifier stack diodes",
  "Standard protections include Pressure release valve, Pressure Switch, Oil level gauge, Oil temperature dial thermometer.",
  "Doubly wound, cross-over windings with electrostatic shield between HV & LV winding",
  "HV rectifier stack consists of glass-sealed passive avalanche diodes with controlled avalanche characteristics offer better stability & highest possible immunity to transient travelling waves.",
  "Solenoid Operated Fail-Safe H.V. Grounding Switch.",
  "H.V. Grounding Switch (Oil/Air)",
  "H.V. Isolating Cum Grounding Switch.",
  "Bus-Couplers",
  "Motorized Disconnecting Switch",
  "Motorized Isolator",
];

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .pd { font-family: 'Poppins', sans-serif; color: #202020; background: #fff; }

  .tp-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
    background: #111;
  }
  .tp-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }
  .tp-hero-overlay {
    position: absolute;
    inset: 0;
  }
  .tp-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }
  .tp-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #fff;
    line-height: 120%;
    margin-bottom: 15px;
  }
  .tp-hero-divider {
    width: 320px;
    height: 2px;
    background: #EB2019;
    border: none;
    margin-bottom: 14px;
  }
  .tp-hero-desc {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 140%;
    max-width: 429px;
  }

  .tp-breadcrumb {
    padding: 40px 0 0 0;
  }
  .tp-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap:8px;
  }
  .tp-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    transition: color 0.15s;
  }
  .tp-bc-item:hover { color: #EB2019; }
  .tp-bc-item.active { color: #202020; }
  .tp-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  .tp-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  .tp-section-content {
    padding: 80px 0 120px 0;
  }
  .tp-content-grid {
    display: flex;
    gap: 90px;
    align-items: flex-start;
  }
  .tp-content-left {
    flex: 0 0 594px;
  }
  .tp-red-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 14px;
    line-height:120%;
  }
  .tp-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 14px;
  }
  .tp-para {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 140%;
  }
  .tp-para + .tp-para { margin-top: 14px; }

  .tp-slider {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  .tp-slider-img-wrap {
    width: 100%;
    height: 500px;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    cursor: grab;
    user-select: none;
  }
  .tp-slider-img-wrap:active { cursor: grabbing; }
  .tp-slider-track {
    display: flex;
    height: 100%;
    transition: transform 0.4s ease;
  }
  .tp-slider-track .tp-slider-img {
    min-width: 100%;
    flex-shrink: 0;
  }
  .tp-slider-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .tp-slider-dots {
    display: flex;
    justify-content: center;
    gap: 8px;
  }
  .tp-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #B8B7B7;
    border: none;
    cursor: pointer;
    padding: 0;
    transition: background 0.2s;
  }
  .tp-dot.active { background: #EB2019; }
  .tp-tabs-section:last-child {
    padding: 00px 0 120px 0;
  }

  .tp-divider {
    max-width: 1600px;
    margin: 0 auto;
    padding: 80px 102px 105px 102px;
  }
  .tp-divider hr {
    border: none;
    border-top: 1px solid #EB2019;
    opacity: 0.3;
  }

  .tp-tabs-section {
    padding: 0px 0 0px 0;
  }

  .tp-spec-heading {
    font-family: 'Poppins', sans-serif;
    font-size: 32px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 60px;
  }

  .tp-tabs-bar {
    display: flex;
    margin-bottom: 42px;
    overflow: visible;
  }

  .tp-tab-active {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    padding: 18px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 400;
    background: #B91E1A;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    transition: background 0.2s;
  }
  .tp-tab-active::after {
    content: '';
    position: absolute;
    bottom: -13px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 13px solid transparent;
    border-right: 13px solid transparent;
    border-top: 13px solid #B91E1A;
    z-index: 2;
  }

  .tp-tab-inactive {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    padding: 20px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 400;
    background: #F1F1F1;
    color: #202020;
    border: none;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
  }
  .tp-tab-inactive:hover { background: #e4e4e4; }

  .tp-tab-icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }
  .tp-tab-active .tp-tab-icon {
    filter: brightness(0) invert(1);
  }
  .tp-tab-inactive .tp-tab-icon {
    filter: brightness(0);
  }

  .tp-features-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .tp-features-list li {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    padding: 4px 0 4px 20px;
    position: relative;
  }
  .tp-features-list li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #202020;
  }

  .tp-spec-img-wrap {
    display: block;
    max-width: 698px;
  }
  .tp-spec-img {
    width: 100%;
    display: block;
    border-radius: 6px;
  }

  .tp-download-list {
    display: flex;
    flex-direction: column;
    margin-left: 50%;
    border: 1px solid #B8B8B8;
    border-radius: 0px;
    overflow: hidden;
  }
  .tp-download-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    background: #Ffffff;
    border-bottom: 1px solid #B8B8B8;
    text-decoration: none;
    transition: background 0.2s;
  }
  .tp-download-row:last-child { border-bottom: none; }
  .tp-download-row:hover { background: #F6F6F6; }
  .tp-download-label {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 400;
    color: #202020;
    padding: 0px 24px;
    border-radius:none;
    flex: 1;
  }
  .tp-download-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 18px 60px;
    border-left: 1px solid #B8B8B8;
  }
  .tp-pdf-icon {
    width: 44px;
    height: 44px;
    display: block;
  }

  @media (max-width: 768px) {
    .tp-hero              { height: 300px; }
    .tp-hero-content      { padding: 0 32px; }
    .tp-hero-title        { font-size: 30px; }
    .tp-hero-divider      { width: 260px; }
    .tp-hero-desc         { font-size: 14px; }

    .tp-breadcrumb        { padding: 28px 0 0 0; }
    .tp-breadcrumb-inner  { padding: 0 32px; }
    .tp-inner             { padding: 0 32px; }
    .tp-divider           { padding: 40px 32px; }

    .tp-section-content   { padding: 40px 0px 0px 0px; }
    .tp-content-grid      { flex-direction: column-reverse; gap: 24px; }
    .tp-tabs-bar          { margin-bottom: 30px; }
    .tp-red-title         { font-size: 24px; margin-bottom: 10px; }
    .tp-subtitle          { font-size: 18px; margin-bottom: 10px; }
    .tp-para + .tp-para   { margin-top: 10px; }
    .tp-para              { font-size: 14px; }
    .tp-content-left      { flex: none; width: 100%; }
    .tp-slider-img-wrap   { height: 280px; }

    .tp-tabs-section      { padding: 40px 0 0px 0; }
    .tp-spec-heading      { font-size: 24px; margin-bottom: 24px; }
    .tp-tab-active        { font-size: 14px; padding: 16px 12px; }
    .tp-tab-inactive      { font-size: 14px; padding: 16px 12px; }
    .tp-features-list li  { font-size: 14px; }
    .tp-download-list     { margin-left: 0; }
    .tp-download-label    { font-size: 18px; padding: 0px 20px; }
    .tp-pdf-icon          { width: 32px; height: 32px; }
    .tp-tabs-section:last-child { padding: 00px 0 40px 0; }
  }

  @media (max-width: 480px) {
    .tp-hero              { height: 400px; }
    .tp-hero-content      { padding: 0 16px; }
    .tp-hero-title        { font-size: 24px; }
    .tp-hero-divider      { width: 100%; margin-bottom: 15px; }
    .tp-hero-desc         { font-size: 14px; }

    .tp-breadcrumb        { padding: 22px 0 0 0; }
    .tp-breadcrumb-inner  { padding: 0 16px; gap: 16px; }
    .tp-bc-item           { font-size: 14px; }
    .tp-bc-sep            { width: 18px; height: 18px; margin: 0 4px; }
    .tp-inner             { padding: 0 16px; }
    .tp-divider           { padding: 0 16px; }
    .tp-tab-icon          { width: 19px; height: 19px; }

    .tp-section-content   { padding: 30px 0; }
    .tp-content-grid      { gap: 30px; }
    .tp-red-title         { font-size: 20px; margin-bottom: 20px; }
    .tp-subtitle          { font-size: 16px; margin-bottom: 20px; }
    .tp-para              { font-size: 14px; }
    .tp-slider-img-wrap   { height: 259px; }
    .tp-dot               { width: 5px; height: 5px; }

    .tp-tabs-section      { padding: 28px 0 60px 0; }
    .tp-tabs-bar          { flex-direction: row; }
    .tp-tab-active        { flex: none; font-size: 16px; padding: 14px 16px; width: 50%; }
    .tp-tab-active::after { display: none; }
    .tp-tab-inactive      { flex: none; font-size: 16px; padding: 14px 16px; width: 50%; }
    .tp-features-list li  { font-size: 14px; }
    .tp-download-label { font-size: 14px;}
        .tp-pdf-icon {width:24px; height:24px;}
    .tp-spec-heading      { font-size: 16px; margin-bottom: 30px; margin-top: 60px; }
    .tp-tabs-section:last-child { padding: 00px 0 60px 0; }
  }
`;

const FeaturesIcon = () => <img src={FeaturesTabIcon} alt="" className="tp-tab-icon" />;
const SpecIcon     = () => <img src={SpecTabIcon}     alt="" className="tp-tab-icon" />;
const DownloadIcon = () => <img src={DownloadTabIcon} alt="" className="tp-tab-icon" />;
const PdfIcon      = () => <img src={PdfSvgIcon}      alt="PDF" className="tp-pdf-icon" />;

const SectionWithDownload = ({ heading, defaultTab, mainTab, mainContent, downloads }) => {
  const [active, setActive] = React.useState(defaultTab);
  return (
    <section className="tp-tabs-section">
      <div className="tp-inner">
        {heading && <h2 className="tp-spec-heading">{heading}</h2>}
        <div className="tp-tabs-bar">
          <button
            className={active === "main" ? "tp-tab-active" : "tp-tab-inactive"}
            onClick={() => setActive("main")}
          >
            {mainTab.icon} {mainTab.label}
          </button>
          <button
            className={active === "download" ? "tp-tab-active" : "tp-tab-inactive"}
            onClick={() => setActive("download")}
          >
            <DownloadIcon /> Download
          </button>
        </div>
        {active === "main" && mainContent}
        {active === "download" && (
          <div className="tp-download-list">
            {downloads.map((item, i) => (
              <a key={i} href={item.href} className="tp-download-row">
                <span className="tp-download-label">{item.label}</span>
                <span className="tp-download-icon"><PdfIcon /></span>
              </a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default function ThreePhaseSolutions() {
  const [activeSlide, setActiveSlide] = useState(0);
  const intervalRef = useRef(null);
  const dragStartX  = useRef(null);

  const startAutoplay = () => {
    intervalRef.current = setInterval(() => {
      setActiveSlide(prev => (prev + 1) % SLIDES.length);
    }, AUTOPLAY_SPEED);
  };

  const stopAutoplay = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  useEffect(() => {
    startAutoplay();
    return () => stopAutoplay();
  }, []);

  const goToSlide = (i) => {
    stopAutoplay();
    setActiveSlide(i);
    startAutoplay();
  };

  const onDragStart = (e) => {
    dragStartX.current = e.type === "touchstart" ? e.touches[0].clientX : e.clientX;
    stopAutoplay();
  };

  const onDragEnd = (e) => {
    if (dragStartX.current === null) return;
    const endX = e.type === "touchend" ? e.changedTouches[0].clientX : e.clientX;
    const diff  = dragStartX.current - endX;
    if (Math.abs(diff) > 50) {
      setActiveSlide(prev =>
        diff > 0
          ? (prev + 1) % SLIDES.length
          : (prev - 1 + SLIDES.length) % SLIDES.length
      );
    }
    dragStartX.current = null;
    startAutoplay();
  };

  return (
    <div className="pd">
      <style>{CSS}</style>

      {/* ══ 1. HERO ══ */}
      <section className="tp-hero">
        {HeroBgImg && <img className="tp-hero-bg" src={HeroBgImg} alt="" />}
        <div className="tp-hero-overlay" />
        <div className="tp-hero-content">
          <h1 className="tp-hero-title">3 Phase Solutions</h1>
          <hr className="tp-hero-divider" />
          <p className="tp-hero-desc">
            Our Third generation micro-controller for electrostatic precipitator applications helps regulate, monitor and optimize the electric power input to the ESP.
          </p>
        </div>
      </section>

      {/* ══ 2. BREADCRUMB ══ */}
      <nav className="tp-breadcrumb" aria-label="Breadcrumb">
        <div className="tp-breadcrumb-inner">
          <a href="/" className="tp-bc-item">Home</a>
          <span className="tp-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/products" className="tp-bc-item">Products</a>
          <span className="tp-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/products/esp-power-supplies" className="tp-bc-item">ESP Power Supplies</a>
          <span className="tp-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="tp-bc-item active">3-Phase Solutions</span>
        </div>
      </nav>

      {/* ══ 3. CONTENT ══ */}
      <section className="tp-section-content">
        <div className="tp-inner">
          <div className="tp-content-grid">

            {/* Left */}
            <div className="tp-content-left">
              <h2 className="tp-red-title">3 Phase Solutions</h2>
              <h3 className="tp-subtitle">3-Phase High Voltage T/R Set</h3>
              <p className="tp-para">The ESP power supplies were introduced in 1970s & ever since have a good field-proven performance. They consist primarily of a Thyristor controlled power-circuit, wherein the firing of the Thyristor is controlled to provide a pulse-by-pulse control of the load current.</p>
              <p className="tp-para">The controlled firing of the Thyristors ensures a low ripple in the output.</p>
              <p className="tp-para">Majority of them operate at a fixed frequency of 50 Hz.</p>
              <p className="tp-para">Depending on the customer's availability of power supply, Ador offers the flexibility of providing High Voltage Transformer Rectifier units in both the Single-phase and Three-phase options.</p>
              <p className="tp-para">The Three-phase option has clearly some distinct advantage, that it offers a substantially low ripple content in the output waveform.</p>
              <p className="tp-para">Manufacturing range: 30 kV(P) to 200 kV(P) ; 50 mA to 4000 mA</p>
            </div>

            {/* Right — slider */}
            <div className="tp-slider">
              <div
                className="tp-slider-img-wrap"
                onMouseDown={onDragStart}
                onMouseUp={onDragEnd}
                onMouseLeave={() => { dragStartX.current = null; startAutoplay(); }}
                onTouchStart={onDragStart}
                onTouchEnd={onDragEnd}
              >
                <div
                  className="tp-slider-track"
                  style={{ transform: `translateX(-${activeSlide * 100}%)` }}
                >
                  {SLIDES.map((src, i) => (
                    <img
                      key={i}
                      className="tp-slider-img"
                      src={src}
                      alt={`Slide ${i + 1}`}
                      draggable={false}
                    />
                  ))}
                </div>
              </div>
              <div className="tp-slider-dots">
                {SLIDES.map((_, i) => (
                  <button
                    key={i}
                    className={`tp-dot${activeSlide === i ? " active" : ""}`}
                    onClick={() => goToSlide(i)}
                    aria-label={`Slide ${i + 1}`}
                  />
                ))}
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ══ 4. SALIENT FEATURES SECTION ══ */}
      <SectionWithDownload
        defaultTab="main"
        mainTab={{ icon: <FeaturesIcon />, label: "Salient Features" }}
        mainContent={
          <ul className="tp-features-list">
            {SALIENT_FEATURES.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        }
        downloads={[
          { label: "3-Phase Solutions Brochure", href: "#" },
          { label: "3-Phase Solutions Datasheet", href: "#" },
        ]}
      />

      {/* ══ DIVIDER ══ */}
      <div className="tp-divider"><hr /></div>

      {/* ══ 5. SPECIFICATION SECTION ══ */}
      <SectionWithDownload
        heading="ADOR-CORONA T/R Sets"
        defaultTab="main"
        mainTab={{ icon: <SpecIcon />, label: "Specification" }}
        mainContent={
          <div className="tp-spec-img-wrap">
            <img className="tp-spec-img" src={SpecImg} alt="Specification" />
          </div>
        }
        downloads={[
          { label: "ADOR-CORONA T/R Sets Specification", href: "#" },
          { label: "ADOR-CORONA T/R Sets Datasheet", href: "#" },
        ]}
      />

    </div>
  );
}